import React from 'react';
import { Box, Skeleton } from '@mui/material';

export const ReimbursementShimmerLoader = () => {
  return (
    <Box
      sx={{
        padding: 3,
        width: 'auto',
        margin: '0 auto'
      }}
    >
      <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
        <Skeleton variant="text" width={40} height={24} />
        <Skeleton variant="text" width={24} height={24} />
        <Skeleton variant="text" width={120} height={24} />
        <Skeleton variant="text" width={24} height={24} />
        <Skeleton variant="text" width={150} height={24} />
      </Box>

      <Skeleton variant="text" width={300} height={40} sx={{ mb: 4 }} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 3,
          mb: 3
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 2
          }}
        >
          <Skeleton variant="rectangular" height={200} animation="wave" />
          <Skeleton variant="rectangular" height={120} animation="wave" />
        </Box>

        <Box sx={{ flex: 1 }}>
          <Skeleton variant="rectangular" height={340} animation="wave" />
        </Box>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Skeleton variant="rectangular" height={200} animation="wave" />
      </Box>
    </Box>
  );
};
